const QRCode = require('qrcode-svg');

import {
  getQrCodeButtonElement,
  getQrCodeModalElement,
  generateQrUrl,
  mobileArLinkGenerator,
  isDeviceSupportsAr
} from './ARQR.helpers';

/**
 * AR button will show a modal with QR code on desktop and will initial AR on mobile devices
 * that support this feature
 */
export class ARQR {
  constructor(container) {
    this.rootElem = container.parentNode;
    this._arLink = null;
  }

  updateQrCodeModal(url) {
    if (isDeviceSupportsAr) {
      return;
    }
    const qrCode = new QRCode({
      padding: 4,
      content: url,
      width: 256,
      height: 256,
      color: '#000000',
      background: '#ffffff',
      ecl: 'Q',
      join: true,
      swap: true,
      container: 'svg-viewbox'
    });

    this.rootElem.querySelector('.qr').innerHTML = qrCode.svg();
    this.rootElem.querySelector('.qr-url').innerHTML = `<a href="${url}">${url.substring(
      0,
      20
    )}...</a>`;
    const linkElem = this.rootElem.querySelector('.qr-url a');
    linkElem.addEventListener('click', async e => {
      e.preventDefault();
      try {
        await navigator.clipboard.writeText(url);
      } catch (e) {
        // well, if we can't copy to clipboard, nothing to do there..
      }
    });
  }

  displayQrCodeModal(display = true) {
    this.rootElem.querySelector('.qr-code-modal').classList.toggle('show', display);
  }

  displayArButton(display = true) {
    const arButtonSlot = document.createElement('div');
    this.rootElem.appendChild(arButtonSlot);
    arButtonSlot.style.display = display ? 'block' : 'none';
  }

  updateArLink(href) {
    this._arLink = href;
  }

  displayArElements(cloudName, publicId) {
    const onClick = e => {
      // prevent passing the event to other elements on the scene
      e.stopImmediatePropagation();
      if (!isDeviceSupportsAr) {
        this.displayQrCodeModal();
      } else {
        const anchor = document.createElement('a');
        anchor.setAttribute('href', this._arLink);

        // Needed for ios
        anchor.appendChild(document.createElement('img'));
        anchor.rel = 'ar';

        // Click the link
        anchor.click();
      }
    };

    const arButton = getQrCodeButtonElement();
    this.rootElem.appendChild(arButton);
    this.rootElem.querySelector('.ar-button').addEventListener('click', onClick);

    // QR Modal - don't mount if on mobile device that supports AR
    if (!isDeviceSupportsAr) {
      const qrModal = getQrCodeModalElement();
      this.rootElem.appendChild(qrModal);

      // hide modal on click outside of the qr modal
      this.rootElem.querySelector('.qr-close').addEventListener('click', () => {
        this.displayQrCodeModal(false);
      });
    }

    const qrUrl = generateQrUrl({
      cloudName,
      publicId
      // placement,
      // variantId: variant?.id,
      // locale
    });
    const arUrl = mobileArLinkGenerator({
      cloudName,
      publicId
      // variant,
      // placement
    });

    this.updateQrCodeModal(qrUrl);
    this.updateArLink(arUrl);
  }
}
